module.exports = __webpack_public_path__ + "img/cangku.49845798.png";